import { Hotel, Product } from '@/types';

const API_BASE_URL = 'https://smart-place-order-api.qubit-home.workers.dev';

export const getHotelById = async (hotelId: string, token: string): Promise<Hotel | null> => {
  try {
    const res = await fetch(`${API_BASE_URL}/hotels/${hotelId}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    if (!res.ok) return null;
    const data = await res.json();
    return data;
  } catch (err) {
    console.error('Error fetching hotel:', err);
    return null;
  }
};

export const getProductById = async (hotelId: string, productId: string, token: string): Promise<Product | null> => {
  try {
    const res = await fetch(`${API_BASE_URL}/products/${hotelId}/${productId}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (!res.ok) return null;
    const data = await res.json();
    return data;
  } catch (err) {
    console.error('Error fetching product:', err);
    return null;
  }
};

export const getPromotions = async (hotelId: string, token: string): Promise<Product[]> => {
  try {
    const res = await fetch(`${API_BASE_URL}/promotions/${hotelId}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (!res.ok) return [];
    const data = await res.json();
    return data;
  } catch (err) {
    console.error('Error fetching promotions:', err);
    return [];
  }
};